import styled from '@emotion/styled';

import { DropdownPrimary, Input } from '@Calix-Commerce/design-system/components';

export const SearchWrapper = styled.form`
  display: flex;
  margin-bottom: 5rem;
  margin-top: 3.5rem;
`;

export const SearchTypeDropdown = styled(DropdownPrimary)`
  width: 215px;
  margin-right: 1rem;
`;

export const SearchTermInput = styled(Input)`
  width: 550px;
  margin-right: 1rem;
`;

export const DateInput = styled(SearchTermInput)`
  width: 150px;
  padding-right: 1rem;
`;
